"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContainer = exports.ImageContainer = exports.HeaderTitle = exports.HeaderIcon = exports.HeaderAdditionalContent = exports.HeaderActions = exports.Header = exports.Content = exports.CloseBtn = exports.Body = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _contextMenu = require("../../Button/styles/contextMenu");
var _buttonGroup = require("../../Button/styles/buttonGroup");
var _NavigationClose = _interopRequireDefault(require("../../Icons/NavigationClose"));
const ModalContainer = exports.ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__ModalContainer",
  componentId: "sc-4c7a36-0"
})(["display:flex;flex-direction:column;background-color:", ";box-shadow:", ";opacity:", ";border-radius:", ";transition-delay:0.07s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);transition-duration:0.35s;transition-property:opacity,transform,-webkit-transform;transform:", ";max-width:96vw;width:", ";min-width:500px;min-height:200px;max-height:90vh;padding:", ";position:relative;overflow:hidden;", "{z-index:100;}", ""], ({
  theme
}) => theme.colors.modal.bg, ({
  theme
}) => theme.colors.modal.shadow, ({
  active
}) => active ? 1 : 0, ({
  theme
}) => theme.modals.borderRadius, ({
  active
}) => active ? 'translateY(0%)' : 'translateY(-4rem)', ({
  fullScreenMode
}) => fullScreenMode ? '90vw' : '50vw', ({
  theme
}) => theme.modals.padding, _contextMenu.ContextMenuList, ({
  theme
}) => theme.name === 'mds' && `
    ${_buttonGroup.ButtonGroup} {
      margin-top: 12px;
    }
  `);
const Header = exports.Header = _styledComponents.default.header.withConfig({
  displayName: "styles__Header",
  componentId: "sc-4c7a36-1"
})(["align-items:center;display:flex;flex-direction:row;flex-shrink:0;background-color:", ";border-bottom:1px solid ", ";padding:", ";color:", ";height:", ";justify-content:", ";"], ({
  theme
}) => theme.colors.modal.headerBg, ({
  theme
}) => theme.colors.modal.headerBorder, ({
  theme
}) => theme.modals.headerPadding, ({
  theme
}) => theme.colors.modal.headerText, ({
  theme
}) => theme.modals.headerHeight, ({
  theme
}) => theme.modals.headerTitlePosition);
const ImageContainer = exports.ImageContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__ImageContainer",
  componentId: "sc-4c7a36-2"
})(["display:flex;justify-content:center;padding:12px 0 12px;"]);
const HeaderIcon = exports.HeaderIcon = _styledComponents.default.div.withConfig({
  displayName: "styles__HeaderIcon",
  componentId: "sc-4c7a36-3"
})(["margin-right:8px;svg{width:32px;height:32px;vertical-align:middle;}"]);
const HeaderTitle = exports.HeaderTitle = _styledComponents.default.h1.withConfig({
  displayName: "styles__HeaderTitle",
  componentId: "sc-4c7a36-4"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";text-transform:", ";letter-spacing:", ";padding:", ";margin:0;"], ({
  theme
}) => theme.modals.title.fontFamily, ({
  theme
}) => theme.modals.title.fontSize, ({
  theme
}) => theme.modals.title.fontWeight, ({
  theme
}) => theme.modals.title.lineHeight, ({
  theme
}) => theme.modals.title.textTransform, ({
  theme
}) => theme.modals.title.letterSpacing, ({
  theme
}) => theme.modals.title.padding);
const HeaderActions = exports.HeaderActions = _styledComponents.default.div.withConfig({
  displayName: "styles__HeaderActions",
  componentId: "sc-4c7a36-5"
})(["bottom:auto;top:", ";right:", ";position:absolute;svg{vertical-align:middle;}"], ({
  theme
}) => theme.modals.title.actionsTop, ({
  theme
}) => theme.modals.title.actionsRight);
const CloseBtn = exports.CloseBtn = (0, _styledComponents.default)(_NavigationClose.default).withConfig({
  displayName: "styles__CloseBtn",
  componentId: "sc-4c7a36-6"
})(["fill:", ";cursor:pointer;margin-left:8px;vertical-align:middle;&:hover{fill:", ";}", ""], ({
  theme
}) => theme.colors.modal.icon, ({
  theme
}) => theme.colors.modal.iconHover, ({
  disabled
}) => disabled && `
    opacity: 0.1;
  `);
const Body = exports.Body = _styledComponents.default.div.withConfig({
  displayName: "styles__Body",
  componentId: "sc-4c7a36-7"
})(["position:relative;overflow-y:auto;flex-grow:1;", ";"], ({
  isLoading
}) => isLoading && `
    overflow: hidden;
    display: flex;
  `);
const Content = exports.Content = _styledComponents.default.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-4c7a36-8"
})(["padding:", ";overflow:auto;flex:1 1 auto;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";"], ({
  theme
}) => theme.modals.content.padding, ({
  theme
}) => theme.modals.content.fontFamily, ({
  theme
}) => theme.modals.content.fontSize, ({
  theme
}) => theme.modals.content.fontWeight, ({
  theme
}) => theme.modals.content.lineHeight);
const HeaderAdditionalContent = exports.HeaderAdditionalContent = _styledComponents.default.div.withConfig({
  displayName: "styles__HeaderAdditionalContent",
  componentId: "sc-4c7a36-9"
})(["display:flex;flex-direction:row;align-items:center;margin-left:8px;"]);